import React from "react";

//import { Link } from "react-router-dom";

import Layout from "../../layout/Layout";

import SEO from '../../ui/SEO';

import "./Code.css";

import preview_weekle from "./preview_weekle.png";
import preview_greasepig_speedrunchampions from "./preview_greasepig_speedrunchampions.jpg";
import preview_craftyball from "./preview_craftyball.png";
import preview_space from "./preview_space.jpg";
import preview_pocketodds from "./preview_pocketodds.png";
import preview_torus from "./preview_torus.png";
import preview_spirograph from "./preview_spirograph.png";
import preview_snake from "./preview_snake.png";
import preview_pipepanic from "./preview_pipepanic.jpg";
import preview_ninjamaze from "./preview_ninjamaze.png";
import preview_functions3d from "./preview_functions3d.png";
import preview_colours from "./preview_colours.png";
import preview_canvascape from "./preview_canvascape.png";

const _BLANK = "_blank";

const CodeIndex = () => 
  (
    <Layout onCode>
      <SEO title="BenJoffe.com"
        description="Some hobby projects, apps, demos and visualisations I've made over the years."
        />
      <div className="Code">
        <p>
          Some hobby projects, apps, demos and visualisations I've made over
          the years.
        </p>

        <h2>2023</h2>

        <ul class="apps">
          <li>
            <a
              href="https://benjoffe.com/weekle"
            >
              <em>Weekle - A game to learn how to calculate the date-of-the-week for any date.</em>
              <span>
                <img
                  src={preview_weekle}
                  alt="Screenshot of Weekle"
                />
              </span>
            </a>
          </li>
        </ul>

        <h2>2018</h2>

        <ul class="apps">
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/watch?v=XpounXuqFoo"
            >
              <em>New YouTube Channel - Speedrun Champions</em>
              <span>
                <img
                  src={preview_greasepig_speedrunchampions}
                  alt="Screenshot of Video"
                />
              </span>
            </a>
          </li>
        </ul>

        <h2>2016</h2>

        <ul class="apps">
          <li>
            <a
              target={_BLANK}
              href="https://craftyball.benjoffe.com/"
            >
              <em>CraftyBall (demo game)</em>
              <span>
                <img
                  src={preview_craftyball}
                  alt="Screenshot of CraftyBall"
                />
              </span>
            </a>
          </li>
          <li>
            <a href="/space/">
              <em>Space Game Concept Screenshots</em>
              <span>
                <img
                  src={preview_space}
                  alt="Screenshot of Solar System Game"
                />
              </span>
            </a>
          </li>
        </ul>

        <h2>2010</h2>

        <ul class="apps">
          <li>
            <a href="https://pocketodds.benjoffe.com/">
              <em>Pocket Odds - Texas Holdem odds calculator</em>
              <span>
                <img
                  src={preview_pocketodds}
                  alt="Screenshot of Pocket Odds"
                />
              </span>
            </a>
          </li>
        </ul>

        <h2>2006</h2>

        <ul class="apps">
          <li>
            <a href="/code/games/torus/">
              <em>Torus</em>
              <span>
                <img src={preview_torus} alt="Screenshot of Torus" />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/toys/spirograph/">
              <em>Spirograph</em>
              <span>
                <img
                  src={preview_spirograph}
                  alt="Screenshot of Spirograph"
                />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/games/snake/">
              <em>Honeycomb Snake</em>
              <span>
                <img
                  src={preview_snake}
                  alt="Screenshot of Honeycomb Snake"
                />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/games/pipepanic/">
              <em>Pipe Panic</em>
              <span>
                <img src={preview_pipepanic} alt="Screenshot of Pipe Panic" />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/games/ninjamaze/">
              <em>Ninja Maze</em>
              <span>
                <img src={preview_ninjamaze} alt="Screenshot of Ninja Maze" />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/tools/functions3d/">
              <em>Functions 3D</em>
              <span>
                <img
                  src={preview_functions3d}
                  alt="Screenshot of Functions 3D"
                />
              </span>
            </a>
          </li>
          <li>
            <a href="/code/tools/colours/">
              <em>Colour Picker</em>
              <span>
                <img
                  src={preview_colours}
                  alt="Screenshot of Colour Picker"
                />
              </span>
            </a>
          </li>
        </ul>

        <h2>2005</h2>

        <ul className="apps">
          <li>
            <a href="/code/demos/canvascape/">
              <em>Canvascape "3D Walker"</em>
              <span>
                <img
                  src={preview_canvascape}
                  alt="Screenshot of Canvascape"
                />
              </span>
            </a>
          </li>
        </ul>
      </div>
    </Layout>
  );

export default CodeIndex;